export var PushNotificationAction;
(function (PushNotificationAction) {
    PushNotificationAction[PushNotificationAction["navigate_to_notification"] = 2] = "navigate_to_notification";
    PushNotificationAction[PushNotificationAction["navigate_to_deep_link"] = 22] = "navigate_to_deep_link";
})(PushNotificationAction || (PushNotificationAction = {}));
